<template>
	<div style="height: 100%;">
		<page v-if="$route.path === '/Culture/Tea'">
			<listTemplate page-title="List" :pid="$cid.english.culture.childs.tea" :page-size="6" type="list"
				@article-click="articleClick"></listTemplate>

		</page>
		<router-view v-else></router-view>
	</div>
</template>
<script>
	import listTemplate from "~/components/entemplate/listTemplate.vue";

	export default {
		components: {
			listTemplate
		},
		data() {
			return {
				pid: null,
			}
		},
		methods: {
			articleClick(item) {
				this.$openNewWindow('/new/Culture/Tea/TeaDetail?id=' + item.id);
			}
		}
	}
</script>



// WEBPACK FOOTER //
// src/views/english/Culture/Tea.vue